var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EBEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5281_43493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 13.625H10.2083V11.75C10.2083 11.5842 10.1424 11.4253 10.0252 11.3081C9.90798 11.1908 9.74901 11.125 9.58325 11.125C9.41749 11.125 9.25852 11.1908 9.14131 11.3081C9.0241 11.4253 8.95825 11.5842 8.95825 11.75V24.25C8.95825 24.4158 9.0241 24.5747 9.14131 24.6919C9.25852 24.8092 9.41749 24.875 9.58325 24.875C9.74901 24.875 9.90798 24.8092 10.0252 24.6919C10.1424 24.5747 10.2083 24.4158 10.2083 24.25V21.75H26.4583V24.25C26.4583 24.4158 26.5241 24.5747 26.6413 24.6919C26.7585 24.8092 26.9175 24.875 27.0833 24.875C27.249 24.875 27.408 24.8092 27.5252 24.6919C27.6424 24.5747 27.7083 24.4158 27.7083 24.25V16.75C27.7083 15.9212 27.379 15.1263 26.793 14.5403C26.2069 13.9542 25.4121 13.625 24.5833 13.625ZM10.2083 14.875H15.8333V20.5H10.2083V14.875ZM17.0833 20.5V14.875H24.5833C25.0805 14.875 25.5574 15.0725 25.9091 15.4242C26.2607 15.7758 26.4583 16.2527 26.4583 16.75V20.5H17.0833Z",
    fill: "#2152FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5281_43493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.33325 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeries);
export default __webpack_public_path__ + "static/media/surgeries.344a54d78b061db26a2d63e7bd8b3dfb.svg";
export { ForwardRef as ReactComponent };